angular.module('lf.common')

.factory('authenticationService', function ($http, $rootScope) {
  
  var authenticationService = {
	
	/*
     * This method submits the login credentials to the backend service that
     * authenticates the credentials returns the authentication response.
     * 
     */
    loginUser: function (params) {
    	
    	/* post data in the form of javascript object literal */
    	var postData = { 
			login: params.login,
	        password: params.password,
	        requesterId: "singlePageCheckout"
    	};
    	
    	return $http({
    		method: 'POST',
    		url: lf.data.xhr.loginAjax,
    		/* "Note: We are not using "params" attribute here as it would send the credentials data in query string.
    		 * Instead, we are using "data" attribute to send the user credentials data in message body.
    		 * "$.param" is a jquery function that serializes the data (javascript object literal). 
    		 * Serialization is required when sending the data in message body. 
    		 */ 
    		data: $.param(postData),
    		headers: { 
    			/* angular $http by default sends the data passed in "data" or "params" attributes as "application/json"
    			 * The Content-Type = 'application/x-www-form-urlencoded' header below makes sure that the data is 
    			 * sent as a String "Name-Value pairs"
    			 */
    			'Content-Type': 'application/x-www-form-urlencoded'
    		}
    	})
    },
    
    /*
     * This method submits the email address entered by guest user to the backend service that
     * verifies that the email address is not already registered in LeapFrog's WebCRM database
     * and initializes web session (also creates guest vindicia account).
     * 
     */
    loginGuest: function (params) {
    	
    	var postParams = {
    			getData: 'guestLoginResponse',
    	        updateData: 'true',
    	        action: 'verifyUserExists',
    	        amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
    		};
    	
    	postParams["/atg/userprofiling/ProfileFormHandler.atg_emailAddress"] = params.emailAddress;
    	postParams["/atg/userprofiling/ProfileFormHandler.atg_initializeGuestWebSession"] = true;
    	
    	return $http({
		    method: 'POST',
			url: lf.data.xhr.shopAction,
			params: postParams, /* params attribute is used to send the form data in query string (URL) */
			headers: {
					/* angular $http by default sends the data passed in "data" or "param" attributes as "application/json"
	    			 * The Content-Type = 'application/x-www-form-urlencoded' header below makes sure that the data is 
	    			 * sent as a String "Name-Value pairs"
	    			 */
					'Content-Type': 'application/x-www-form-urlencoded'
			    }
		  })
    }
    
  }
  
  return authenticationService;
  
});
